import { motion } from "framer-motion";

const values = [
  "Precision",
  "Innovation",
  "Scalability",
  "Transparency",
  "Security",
];

const differentiators = [
  "AI-Native Thinking",
  "Enterprise-Grade Architecture",
  "Lean & Agile Execution",
  "Long-Term Technical Partnership",
];

const CompanySection = () => {
  return (
    <section id="company" className="py-24 md:py-32">
      <div className="container px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <p className="text-sm uppercase tracking-[0.2em] text-primary mb-3 font-body">
            Built for the AI Era
          </p>
          <h2 className="text-3xl md:text-5xl font-bold font-display">
            Who We <span className="text-gradient-red">Are</span>
          </h2>
        </motion.div>

        {/* Vision & Mission */}
        <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-12 mb-20">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h3 className="text-xl font-display font-semibold mb-4 text-foreground">
              Our Vision
            </h3>
            <p className="text-muted-foreground font-body leading-relaxed">
              To create intelligent software systems that evolve, adapt, and scale with businesses in a rapidly transforming digital world.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            <h3 className="text-xl font-display font-semibold mb-4 text-foreground">
              Our Mission
            </h3>
            <p className="text-muted-foreground font-body leading-relaxed">
              Empower organizations with AI-native platforms that drive measurable impact, operational intelligence, and sustainable growth.
            </p>
          </motion.div>
        </div>

        {/* Core Values */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-4xl mx-auto mb-20 text-center"
        >
          <h3 className="text-xl font-display font-semibold mb-8 text-foreground">
            Our Core Values
          </h3>

          <div className="flex flex-wrap justify-center gap-4">
            {values.map((value, i) => (
              <span
                key={i}
                className="px-5 py-2 rounded-full border border-glass bg-card text-sm font-body text-muted-foreground"
              >
                {value}
              </span>
            ))}
          </div>
        </motion.div>

        {/* Why Choose Us */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-4xl mx-auto text-center"
        >
          <h3 className="text-xl font-display font-semibold mb-8 text-foreground">
            Why Choose Us
          </h3>

          <div className="grid md:grid-cols-2 gap-6">
            {differentiators.map((item, i) => (
              <div
                key={i}
                className="p-6 rounded-xl bg-card border border-glass text-muted-foreground font-body"
              >
                ✔ {item}
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CompanySection;